import { Box, Text } from '@chakra-ui/react';
import PersBug from './PersBug';

const PersonalizationChart = ({ props, jobSeekerDataInd }) => {
  const boxAlign =
    props.stateProps.sectionData.sectionType === 'industry'
      ? ['left', null, null, 'right']
      : ['left'];
  const industries = props.stateProps.dataToSave.industry;
  const industry = typeof industries[jobSeekerDataInd['industry']] === 'undefined' ? industries['other'] : industries[jobSeekerDataInd['industry']];

    let illuminated = 0;
    const questionsToShow = [];
  for (const question of industry.questions) {
    if (typeof jobSeekerDataInd[question.qid] !== 'undefined') {
      illuminated++;
    }
    questionsToShow.push(question);
  }
  while(questionsToShow.length < 5) {
    questionsToShow.push({qid:'dummy'});
  }
  return (
    <Box
      textAlign={boxAlign}
      maxWidth='260px'
      sx={{
        flexGrow: 1,
        margin: '0 8px 0 0',
        width: '100%',
      }}
    >
      <Text
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          color: 'BLACK',
          paddingBottom: 1,
        }}
      >
        Personalization
      </Text>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          marginBottom: [2, null, 0],
          bgGradient: 'linear(to-l, green.500, orange.500)',
        }}
      >

        {questionsToShow.map((question, i, row) => {
          if (question.qid !== 'bullets-bacon') {
            return (<PersBug bugIndex={illuminated} illuminated={i} />)
          } else {
            return null;
          }
        })}
      </Box>
    </Box>
  );
};
export default PersonalizationChart;
